import { initializeRealUserMonitoring, RumSettings } from '@chr/common-ui-rum';
import { getBaseUrl } from './getBaseUrl';

async function getConfiguration(): Promise<AppConfig> {
  const url = `${getBaseUrl()}app-config.json`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(
      `Failed to load app configuration from ${url} (HTTP ${response.status})`
    );
  }

  return response.json();
}

(async () => {
  const config = await getConfiguration();

  if (config.rumApplicationId && config.rumClientToken) {
    const rumSettings: RumSettings = {
      enableTracing: false,
      environment: config.environment,
      rumApplicationId: config.rumApplicationId,
      rumClientToken: config.rumClientToken,
      session: {
        privacyLevel: 'mask-user-input',
        sampleRate: 25,
        replaySampleRate: 5,
      },
      uiName: 'GF.Paps.UI.V3',
      uiSemanticVersion: '1.0.0',
    };
    initializeRealUserMonitoring(rumSettings);
  }

  const { bootstrap } = await import('./bootstrap');
  bootstrap(config);
})();
